import ProjectReportSlice from '@rd-web-markets/market/dist/technicalProof/projectReportSlice/ProjectReportSlice';
import React from 'react';
import ActivitiesCommentsList from './ActivitiesComments/ActivitiesCommentsList';
const ProjectActivities = _ref => {
  let {
    handleTinyMce,
    handleSliceChange,
    handleSubmit,
    key,
    index,
    slice,
    report,
    pageAccess,
    setReport,
    reportNotesHandlers
  } = _ref;
  const additionalCommentsSlice = report.project_report_slices.find(s => s.title === 'additional_comments');
  const slices = [additionalCommentsSlice, ...report.project_report_slices.filter(slice => slice.tab === 'activity').filter(s => s.title !== 'additional_comments')].filter(Boolean); // old projects wont have the additional_comments slice

  return /*#__PURE__*/React.createElement(React.Fragment, null, slices.map((slice, index) => /*#__PURE__*/React.createElement(ProjectReportSlice, {
    pageAccess: pageAccess,
    handleTinyMce: handleTinyMce,
    handleSubmit: handleSubmit,
    handleSliceChange: handleSliceChange,
    key: index,
    index: index,
    slice: slice
  })), /*#__PURE__*/React.createElement(ActivitiesCommentsList, {
    setReport: setReport,
    report: report,
    reportNotesHandlers: reportNotesHandlers
  }));
};
export default ProjectActivities;